import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../common/services/cqs/IPrimaryKey";

export class MakuleraArbetsorderCommand extends BasicCommand<MakuleraArbetsorderCommand> {
    get primaryKey(): IPrimaryKey<MakuleraArbetsorderCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "MakuleraArbetsorderCommand";
    constructor(init: (instance: MakuleraArbetsorderCommand) => void) {
        super(MakuleraArbetsorderCommand.$type, MakuleraArbetsorderCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
